import Debouncer from '../lib/Debouncer';
import ViewportTracker from '../lib/ViewportTracker';
/*
	options: {
		threshold: 0 {default};
	}
 */
interface IcreateObserverOptions {
	observedSelector: string;
	targetedSelector?: string;
	options: IntersectionObserverInit;
	intersectionRatio?: number;
}

export default class SiteAnimations {
	constructor() {
		// CTA - single
		this.createObserver({
			observedSelector: '.propertyInfo--header',
			targetedSelector: '.propertyInfo--sticky',
			options: {
				threshold: 0
			},
			intersectionRatio: 0
		});
	}
	private createObserver(opts: IcreateObserverOptions): void {
		const observerElements = document.querySelectorAll(opts.observedSelector);
		// quick exit
		if (observerElements.length == 0){
			return;
		}
		const callback = function(entries: Array<IntersectionObserverEntry>, observer: IntersectionObserver) {
			entries.forEach((entry) => {
				const element = entry.target;
				const targeted = !!opts.targetedSelector ? document.querySelector(opts.targetedSelector) : element;
				window.requestAnimationFrame(function() {
					if (entry.isIntersecting && entry.intersectionRatio >= (opts.intersectionRatio || 0)) {
						targeted.setAttribute('animation', 'setup');
					} else {
						targeted.setAttribute('animation', 'triggered');
					}
				});
			});
		};
		const observer: IntersectionObserver = new IntersectionObserver(callback, opts.options);

		Array.from(observerElements).forEach((element) => {
			const targeted = !!opts.targetedSelector ? document.querySelector(opts.targetedSelector) : element;
			/* This sets up the elements for CSS based animations */
			targeted.setAttribute('animation', 'setup');
			observer.observe(element);
		});
	}
}
